import { Reveal, ChapterTag, GoldButton } from "@/components/Reveal";
import { scrollToId } from "@/constants/site";

const DESTINATIONS = [
  {
    name: "Kashmir",
    tags: "Mountains • Lakes • Nature • Experiences",
    img: "https://images.pexels.com/photos/6730641/pexels-photo-6730641.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=940",
  },
  {
    name: "Goa",
    tags: "Beaches • Leisure • Experiences",
    img: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    name: "Kerala",
    tags: "Backwaters • Nature • Culture",
    img: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    name: "Udaipur",
    tags: "Heritage • Culture • Experiences",
    img: "https://images.unsplash.com/photo-1599661046827-dacff0c0f09a?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
];

export const Destinations = () => (
  <section id="destinations" data-testid="destinations-section" className="grain relative bg-slateDark px-5 py-20 sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <ChapterTag index="06" label="Destinations" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-10 font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-5xl">
          Where Will You <span className="italic text-gold-gradient">Go Next?</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {DESTINATIONS.map((d, i) => (
          <Reveal key={d.name} delay={0.08 + i * 0.1}>
            <button
              data-testid={`destination-card-${d.name.toLowerCase()}`}
              onClick={() => scrollToId("plan")}
              className="group relative block w-full overflow-hidden rounded-sm text-left"
            >
              <img
                src={d.img}
                alt={d.name}
                className="aspect-[3/4] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0C0D0F]/90 via-[#0C0D0F]/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <h3 className="font-serif text-3xl font-light text-zinc-50">{d.name}</h3>
                <p className="mt-2 text-[11px] font-mono uppercase tracking-[0.2em] text-gold/90">{d.tags}</p>
              </div>
              <div className="absolute inset-0 border border-white/0 transition-colors duration-500 group-hover:border-gold/40" />
            </button>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <div className="mt-16 flex flex-col items-start justify-between gap-8 border-t border-white/10 pt-12 lg:flex-row lg:items-center">
          <div>
            <h3 className="font-serif text-2xl font-light text-zinc-100 sm:text-3xl">Have somewhere else in mind?</h3>
            <p className="mt-3 max-w-lg text-sm font-light leading-relaxed text-zinc-400">
              Tell us where you'd like to go. We can explore the possibilities with you — these are just a few
              examples. We plan personalized journeys across India.
            </p>
          </div>
          <GoldButton testId="destinations-plan-cta" onClick={() => scrollToId("plan")}>
            Plan My Journey
          </GoldButton>
        </div>
      </Reveal>
    </div>
  </section>
);
